import type { I18n } from '@lingui/core';
import { msg } from '@lingui/core/macro';

// O que o agente lê do passo Resumo (U24, U46). Arquivo leve: entra nos manifestos (`*.screen.ts`, JS inicial).

/** O estado do Resumo para o contexto do agente: sem nome, CPF nem conta. */
export interface SummaryAgentState {
  readonly personFound: boolean;
  readonly bankAccount: boolean;
  /** Sem `NaturalPerson:Read` não se sabe se a pessoa existe. */
  readonly canReadPerson?: boolean;
  /** O envio voltou sem o número da operação e travou. */
  readonly blocked?: boolean;
}

/** A frase do Resumo no contexto: o que falta para enviar. O envio é só pela pessoa, na tela (sem ferramenta). */
export function summaryContextText(state: SummaryAgentState | null | undefined, i18n: I18n): string {
  if (!state) return '';
  if (state.blocked)
    return i18n._(msg`No Resumo, o envio voltou sem o número da operação, que pode ter sido criada: é preciso conferir a lista de operações antes de tentar de novo.`);
  if (state.canReadPerson === false)
    return i18n._(msg`No Resumo, sem permissão para consultar pessoas físicas: não dá para conferir o titular nem enviar para análise.`);
  if (!state.personFound)
    return i18n._(msg`No Resumo, a pessoa do CPF não está cadastrada: é preciso cadastrá-la antes de enviar para análise.`);
  if (!state.bankAccount)
    return i18n._(msg`No Resumo, a pessoa não tem conta bancária: é preciso adicionar uma antes de enviar para análise.`);
  return i18n._(msg`No Resumo, o titular e a conta estão prontos. Enviar para análise cria a operação e só a pessoa pode pedir, na tela.`);
}
